import { render } from "./IndexMD.vue?vue&type=template&id=a6f09c10"
import script from "./IndexMD.vue?vue&type=script&lang=js"
export * from "./IndexMD.vue?vue&type=script&lang=js"

import "./IndexMD.vue?vue&type=style&index=0&id=a6f09c10&lang=css"

import exportComponent from "C:\\Users\\6217025534\\Desktop\\vsts-agent-win-x64-2\\_work\\40\\s\\PASVue\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__